import { nameOf } from '../shared/common';
import { QueryParser } from '../shared/QueryParser';
import { ModularConfigurationRequestQuotePageQuery } from './ModularConfigurationRequestQuotePageQuery';

export class ModularConfigurationRequestQuotePageQueryParser {
  public static toModel(query: Map<string, string>): ModularConfigurationRequestQuotePageQuery {
    for (const [key, value] of query) {
      query.set(key, decodeURIComponent(value));
    }

    const code = QueryParser.getValue(query, nameOf<ModularConfigurationRequestQuotePageQuery>('code'), '');
    const familyId = QueryParser.getValue(query, nameOf<ModularConfigurationRequestQuotePageQuery>('familyId'), '');
    const embed =
      QueryParser.getValue(query, nameOf<ModularConfigurationRequestQuotePageQuery>('embed')) === true.toString();

    return new ModularConfigurationRequestQuotePageQuery(code, familyId, embed);
  }

  public static toQuery(queryModel: ModularConfigurationRequestQuotePageQuery): Map<string, string> {
    const query = new Map<string, string>();

    Object.entries(queryModel).forEach(([name, value]) => {
      QueryParser.setValue(query, name, encodeURIComponent(value));
    });

    return query;
  }
}
